import { Button } from 'design-system';
import { Link as RouterLink, useNavigate } from 'react-router';

const UnregisteredBanner = () => {
  const navigate = useNavigate();
  return (
    <div className='flex items-center bg-gx-highlight p-6'>
      <div className='flex w-2/3 flex-col'>
        <h2 className='text-h2 font-bold'>See the data in GX Go</h2>
        <p className='text-xl'>
          Sign up for GX Go to explore thousands of oil and energy transition spot prices and
          forward curves - or find out more on the General Index{' '}
          <a
            className='text-gx-text decoration-gx-text/40'
            href='https://www.general-index.com'
            rel='noopener noreferrer'
            target='_blank'
          >
            website
          </a>
          .
        </p>
      </div>
      <div className='flex w-[34%] justify-center'>
        <div className='flex flex-col items-center'>
          <Button
            className='w-[208px] bg-foreground'
            onClick={() => navigate('/onboarding')}
          >
            <span className='font-bold text-primary'>TRY FOR FREE</span>
          </Button>
          <p className='mt-1 text-sm'>
            Already have an account?{' '}
            <RouterLink
              className='font-bold text-gx-text decoration-gx-text/40'
              to='../login'
            >
              Login
            </RouterLink>
          </p>
        </div>
      </div>
    </div>
  );
};

export default UnregisteredBanner;
